import { action, makeAutoObservable, observableShallow } from 'mobx'
import WizardFlowStep from '@Components/WizardFlow/wizard-flow-step'
import RootStore from '@App/stores/root-store'

class WizardFlowStore {
    _currentIndex = 0
    _currentSubIndex = 0
    _flow: WizardFlowStep[] = []
    private rootStore: RootStore
    constructor(rootStore: RootStore) {
        makeAutoObservable(this, { setFlow: action, resetStore: action, _flow: observableShallow })

        this.rootStore = rootStore
    }

    async isCurrentStepValid(): Promise<boolean> {
        const { onNextValidation } = this.currentFlowStep
        const result = onNextValidation ? onNextValidation() : true
        return Promise.resolve(result)
    }

    setFlow = (flow: WizardFlowStep[]) => {
        this._flow = [...flow]
    }

    get currentFlowStep() {
        return this._flow[this._currentIndex]
    }

    get flowLength() {
        return this._flow.length
    }

    get flow() {
        return this._flow
    }

    get currentIndex() {
        return this._currentIndex
    }

    resetIndex = () => {
        this._currentIndex = 0
        this._currentSubIndex = 0
    }

    setCurrentIndex = (index: number) => {
        this._currentIndex = index
    }

    advanceIndex = () => {
        ++this._currentIndex
    }

    decrementIndex = () => {
        --this._currentIndex
    }

    get currentSubIndex() {
        return this._currentSubIndex
    }

    setCurrentSubIndex = (index: number) => {
        this._currentSubIndex = index
    }

    advanceSubIndex = () => {
        ++this._currentSubIndex
    }

    decrementSubIndex = () => {
        --this._currentSubIndex
    }

    get onLastStep() {
        return this._currentIndex === this._flow.length - 1
    }

    get workStore() {
        return this.rootStore.workStore
    }

    resetStore = () => {
        this._currentIndex = 0
        this._currentSubIndex = 0
        this._flow = []
    }
}

export default WizardFlowStore
